// Diffs: [ ] Show annotations
//
// Toggle inline annotations in files
import {on} from 'delegated-events'

on('change', '.js-toggle-file-check-annotations', function (event) {
  const target = event.currentTarget as HTMLInputElement

  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const inlineAnnotations = target.closest<HTMLElement>('.file')!.querySelectorAll('.js-inline-annotations')

  for (const inlineAnnotation of inlineAnnotations) {
    if (!(inlineAnnotation instanceof HTMLElement)) continue
    inlineAnnotation.hidden = !target.checked
  }
})
